export const directoryKey = (userId) => `lxt_fr_directory_v1:${userId}`;
export const readDirectory = (userId) => {
  try { return JSON.parse(sessionStorage.getItem(directoryKey(userId))) || {}; } catch { return {}; }
};
export const saveDirectory = (userId, patch) => {
  try { sessionStorage.setItem(directoryKey(userId), JSON.stringify({ ...readDirectory(userId), ...patch })); } catch { /* navigation remains usable */ }
};
export const directoryUrl = (userId) => {
  const saved = readDirectory(userId);
  const params = new URLSearchParams();
  if (saved.search) params.set('q', saved.search);
  if (saved.category) params.set('category', saved.category);
  return `/job-roles${params.size ? `?${params}` : ''}`;
};
export const categoryLabel = (value) => String(value || '').replace(/^[A-Z]\)\s*/, '');